import script from "./UsageTimeStats.vue?vue&type=script&setup=true&lang=js"
export * from "./UsageTimeStats.vue?vue&type=script&setup=true&lang=js"

import "./UsageTimeStats.vue?vue&type=style&index=0&id=23c51dbb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c51dbb"]])

export default __exports__